import { Add as WirehouseAdd } from './Add';

export default WirehouseAdd;
